import { fromJS, List } from 'immutable';
import * as actionTypes from '../actions/metaAttachActionTypes';
import {
  META_ATTACH_STATE_NONE,
  META_ATTACH_STATE_READY,
  META_ATTACH_STATE_IN_PROGRESS,
  META_ATTACH_STATE_SUCCESS,
  META_ATTACH_STATE_FAILURE,
} from '../constants/metaAttachStates';

const initialState = fromJS({
  metadataToAttach: [],
  state: META_ATTACH_STATE_NONE,
  error: null,
});

const metaAttach = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.META_ATTACH_ADD:
      return state
        .set('metadataToAttach', new List(action.metadata))
        .set('state', META_ATTACH_STATE_READY)
        .set('error', null);
    case actionTypes.META_ATTACH_CLEAR:
      return state
        .set('metadataToAttach', new List([]))
        .set('state', META_ATTACH_STATE_NONE)
        .set('error', null);
    case actionTypes.META_ATTACH_REQUEST:
      return state
        .set('state', META_ATTACH_STATE_IN_PROGRESS)
        .set('error', null);
    case actionTypes.META_ATTACH_SUCCESS:
      return state
        .set('state', META_ATTACH_STATE_SUCCESS)
        .set('error', null);
    case actionTypes.META_ATTACH_FAILURE:
      return state
        .set('state', META_ATTACH_STATE_FAILURE)
        .set('error', action.err);
    default:
      return state;
  }
};

export default metaAttach;



// WEBPACK FOOTER //
// ./src/js/reducers/metaAttach.js